import { render, staticRenderFns } from "./NewDoctorModal.vue?vue&type=template&id=18edf333&scoped=true"
import script from "./NewDoctorModal.vue?vue&type=script&lang=js"
export * from "./NewDoctorModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18edf333",
  null
  
)

export default component.exports